import InventoryCreateDTO from '@src/adapters/dto/inventory/InventoryCreateDTO';
import useApi, { ApiOptions } from '../base/useApi';
import InventoryDTO from '@src/adapters/dto/inventory/InventoryDTO';

interface Params {
  inventory: InventoryCreateDTO;
}

interface Result {
  inventory: InventoryDTO;
}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/inventory/create',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};
export const useCreateInventory = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useCreateInventoryLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useCreateInventory;
